"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_UUID_SLASH_UUID_STRING = exports.REGEXP_UUID_SLASH_UUID = exports.REGEXP_UUID_STRING = exports.REGEXP_UUID = void 0;
exports.REGEXP_UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/i;
exports.REGEXP_UUID_STRING = new RegExp('^' + exports.REGEXP_UUID.source + '$', 'i');
exports.REGEXP_UUID_SLASH_UUID = new RegExp(exports.REGEXP_UUID.source + '/' + exports.REGEXP_UUID.source, 'i');
exports.REGEXP_UUID_SLASH_UUID_STRING = new RegExp('^' + exports.REGEXP_UUID_SLASH_UUID.source + '$', 'i');
//# sourceMappingURL=uuid.regexp.js.map